import API from '../util/ApiUtil';
export const LOGGING_BASE_URL = '/audit-log';
class LoggingApi {
}
Object.defineProperty(LoggingApi, "postLog", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: (path) => {
        return API.post(`${LOGGING_BASE_URL}`, { path: path });
    }
});
export default LoggingApi;
